import { useDispatch } from 'react-redux';
import { ReadMail } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { updateNotificationsRequest } from '../../actions';

export const MarkAllReadButton = () => {
  const dispatch = useDispatch();

  const markAllRead = () => {
    dispatch(updateNotificationsRequest([], true));
  };

  return (
    <Tooltip tooltipContent="Mark all as read">
      <IconButton
        data-test="notificationCenter-markAll"
        onClick={markAllRead}
        size={BUTTON_SIZES.LARGE}
        variant={BUTTON_VARIANTS.SECONDARY}
      >
        <ReadMail />
      </IconButton>
    </Tooltip>
  );
};
